import type { PaletteColorTokens, PrimitiveColorTokens } from '../../types';

export const getPaletteColorTokens = (primitives: PrimitiveColorTokens): PaletteColorTokens => {
  return {
    transparent: primitives.transparent,
    white: primitives.white, // #FFFFFF
    // Deprecated alias of `mono14` (dark-mode plan C6.1).
    black: primitives.gray14, // #0A0A0A

    mono1: primitives.gray1, // #FAFAFA
    mono2: primitives.gray2, // #F5F5F5
    mono3: primitives.gray3, // #E5E5E5
    mono4: primitives.gray4, // #E5E5E5
    mono5: primitives.gray5, // #D4D4D4
    mono6: primitives.gray6, // #A3A3A3
    mono7: primitives.gray7, // #A3A3A3
    mono8: primitives.gray8, // #737373
    mono9: primitives.gray9, // #737373
    mono10: primitives.gray10, // #737373
    mono11: primitives.gray11, // #525252
    mono12: primitives.gray12, // #525252
    mono13: primitives.gray13, // #525252
    mono14: primitives.gray14, // #0A0A0A
    mono15: primitives.gray15, // #171717

    primary1: primitives.purple1, // #EEF2FE
    primary2: primitives.purple2, // #DFE8FE
    primary3: primitives.purple3, // #C4D3FE
    primary4: primitives.purple4, // #A1B5FC
    primary5: primitives.purple5, // #7A8EF9
    primary6: primitives.purple6, // #5A69F2
    primary7: primitives.purple7, // #4A4AFF
    primary8: primitives.purple8, // #3A3BCB // default
    primary9: primitives.purple9, // #3032A4

    // Positive palette
    positive1: primitives.green1, // #F0FDFA
    positive2: primitives.green2, // #CCFBF1
    positive3: primitives.green3, // #99F6E4
    positive4: primitives.green4, // #5EEAD4
    positive5: primitives.green5, // #14B8A6
    positive6: primitives.green6, // #0D9488 // default
    positive7: primitives.green7, // #0F766E
    positive8: primitives.green8, // #134E4A
    positive9: primitives.green9, // #042F2E

    // Negative palette
    negative1: primitives.red1, // #FEF2F2
    negative2: primitives.red2, // #FEE2E2
    negative3: primitives.red3, // #FECACA
    negative4: primitives.red4, // #FCA5A5
    negative5: primitives.red5, // #EF4444
    negative6: primitives.red6, // #DC2626 // default
    negative7: primitives.red7, // #B91C1C
    negative8: primitives.red8, // #7F1D1D
    negative9: primitives.red9, // #450A0A

    // Warning palette
    warning1: primitives.orange1, // #FFF7ED
    warning2: primitives.orange2, // #FFEDD5
    warning3: primitives.orange3, // #FED7AA
    warning4: primitives.orange4, // #FDBA74
    warning5: primitives.orange5, // #F97316
    warning6: primitives.orange6, // #EA580C // default
    warning7: primitives.orange7, // #C2410C
    warning8: primitives.orange8, // #7C2D12
    warning9: primitives.orange9, // #431407

    //  Info palette
    info1: primitives.humana1, // #FAFAFA
    info2: primitives.humana2, // #F5F5F5
    info3: primitives.humana3, // #E5E5E5
    info4: primitives.humana4, // #D4D4D4 // default
    info5: primitives.humana5, // #A3A3A3
    info6: primitives.humana6, // #737373
    info7: primitives.humana7, // #404040
    info8: primitives.humana8, // #262626
    info9: primitives.humana9, // #171717

    // New UI
    brandBlurple: primitives.brandBlurple, // #4267D4

    newUIBrandPrimary: primitives.newUIBrandPrimary, // #4A4AFF
    primaryWeak: primitives.primaryWeak, // #DFE8FE

    // AI palette
    ai1: primitives.ai1, // #25AFFA
    ai2: primitives.ai2, // #4951EF
    ai3: primitives.ai3, // #CE54B3
  };
};
